<template>
  <PickLotteryPlaySlipCard
    v-if="!isFixedStake && priceList"
    class="pt-200 px-200 pb-050 gap-200"
    data-containerid="pick_lottery_wager"
    :headline="$t('picklottery.stake.title')"
  >
    <LcForm :ref="setFormRef" class="w-full" :tracking="{ containerId: 'pick_lottery_stake_form' }">
      <LcFormField v-slot="{ field }" name="stake">
        <ChargeSelector
          v-bind="field"
          :charges="preparedWagers"
          :value="selectedStake"
          @update:value="(value) => setSelectedStake(play.id, value)"
        />
      </LcFormField>
    </LcForm>
  </PickLotteryPlaySlipCard>
</template>

<script lang="ts" setup>
import * as Yup from 'yup'

import type { PickLotteryStepProps, PickLotteryStepRef } from './types'

const validationSchema = Yup.object().shape({
  stake: Yup.string().required(),
})

const { play } = defineProps<PickLotteryStepProps>()

const { setFormRef, validate } = useForm(validationSchema)
const { config, isFixedStake, priceList, setSelectedStake, stakes } = usePlaySlip()

const selectedStake = computed(() => play.stake || '')

const fixedCharges = computed(() => priceList.value?.charges.filter(isFixedCharge) || [])

const preparedWagers = computed(() =>
  stakes.value.map((stake) => ({
    id: stake.price,
    value: fixedCharges.value.find((charge) => charge.id === stake.price)?.value.value ?? 0,
  })),
)

const invokeValidate = () => validate({ stake: selectedStake.value })

onBeforeMount(() => {
  if (selectedStake.value || !config.value) return
  setSelectedStake(play.id, getInitialStake(config.value))
})

defineExpose<PickLotteryStepRef>({ validate: invokeValidate })
</script>
